export default {
  // 一键打开企业微信链接
  wxworkAssistantLink: 'wxwork://message?username=ronsonhuang',
};
